module.exports = __webpack_public_path__ + "static/media/cv_4.e7268406.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Story/assets/cv_4.png
// module id = 616
// module chunks = 0